let isMobile = false;
let mobileSwitchWidth = 0;
let resizeTimeout = 100;

function toggleHeight(el = HTMLElement) {
  if (el.style.height) {
    el.style.height = null;
  } else {
    //el.style.height = el.scrollHeight + "px";
    el.style.height = "fit-content";
  }
}

// Function to disable scroll
function disableScroll() {
  document.addEventListener("touchmove", preventScroll);
  // Save the current scroll position
  const scrollY = window.scrollY;

  // Prevent scrolling on the body
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
  document.body.style.top = `-${scrollY}px`;
}

// Function to enable scroll
function enableScroll() {
  document.removeEventListener("touchmove", preventScroll);
  // Allow scrolling on the body
  document.body.style.position = "";
  document.body.style.width = "";
  document.body.style.top = "";

  // Restore the scroll position
  const scrollY = document.body.style.top;
  window.scrollTo(0, parseInt(scrollY || "0") * -1);
}

// Function to prevent the default scroll behavior
function preventScroll(event) {
  event.preventDefault();
}

function handleMenuResponsiveToggle() {
  const currentWidth = window.innerWidth;
  const mainNavigationElement = document.querySelector(".main-navigation");
  const mobileButtonElement = document.querySelector(".mobile-button");

  if (currentWidth <= 768) {
    mainNavigationElement.classList.remove("desktop-menu");
    mainNavigationElement.classList.add("mobile-menu");
    mobileButtonElement.classList.add("show-mobile-button");
  } else {
    mainNavigationElement.classList.add("desktop-menu");
    mainNavigationElement.classList.remove("mobile-menu");
    mobileButtonElement.classList.remove("show-mobile-button");
  }

  if (currentWidth > 768) {
    if (getMinHeight() + 10 < getActualHeight()) {
      if (!isMobile) {
        // Save the width at the moment of switch to mobile
        mobileSwitchWidth = currentWidth;
        isMobile = true;
      }

      mainNavigationElement.classList.add("mobile-menu");
      mainNavigationElement.classList.remove("desktop-menu");
      mobileButtonElement.classList.add("show-mobile-button");
    } else {
      if (isMobile && currentWidth > mobileSwitchWidth) {
        mainNavigationElement.classList.add("desktop-menu");
        mainNavigationElement.classList.remove("mobile-menu");
        mobileButtonElement.classList.remove("show-mobile-button");
        isMobile = false; // Reset the mobile state
      }
    }
  }
}

function getMinHeight() {
  const navbar = document.querySelector(".region-header");
  const style = window.getComputedStyle(navbar);
  return parseInt(style.minHeight);
}

function getActualHeight() {
  const navbar = document.querySelector(".region-header");
  return navbar.offsetHeight;
}

function handleResize(resizeTimeout) {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    handleMenuResponsiveToggle();
  }, 200); // Adjust the debounce time as needed
}

window.addEventListener("DOMContentLoaded", () => {
  const headerEl = document.querySelector("header");
  const variant = document
    .querySelector("body")
    .getAttribute("data-menu-variation");

  // Menu icon
  const menuButton = document.querySelector(".mobile-button");
  const htmlElement = document.documentElement;

  if (menuButton) {
    menuButton.addEventListener("click", () => {
      menuButton.classList.toggle("open");
      headerEl.classList.toggle("open-menu");

      if (htmlElement.style.overflowY === "hidden") {
        htmlElement.style.overflowY = null;
      } else {
        htmlElement.style.overflowY = "hidden";
      }
    });
  }

  headerEl
    .querySelectorAll(".menu--main .menu-item a")
    .forEach((menuItem) => {
      menuItem.addEventListener("click", (e) => {
        menuButton.classList.remove("open");
        headerEl.classList.remove("open-menu");

        if (htmlElement.style.overflowY === "hidden") {
          htmlElement.style.overflowY = null;
        }
      });
    });

  // Accessible desktop menu
  headerEl
    .querySelectorAll(".menu--main .menu-item--expanded")
    .forEach((menu) => {
      const controllerButton = menu.querySelector('.menu-item-expanded-plus')

      const focusoutEvent = function (event) {
        if (!menu.contains(event.relatedTarget)) {
          menu.classList.remove('visible-submenu');
          controllerButton.setAttribute("aria-expanded", "false");
          document.removeEventListener("focusout", focusoutEvent);
        }
      }

      controllerButton.addEventListener("keydown", (e) => {
        if (e.key == "Space" || e.key == " " || e.key == "Enter") {
          if (controllerButton.getAttribute("aria-expanded") === "false") {
            menu.classList.add('visible-submenu');
            controllerButton.setAttribute("aria-expanded", "true");

            document.addEventListener("focusout", focusoutEvent);
          } else {
            //document.removeEventListener("focusout", focusoutEvent);
            menu.classList.remove('visible-submenu');
            controllerButton.setAttribute("aria-expanded", "false");
          }
        }
      });
    });

  // Mobile menu
  switch (variant) {
    //Sliding menu
    case "variant-1":
      headerEl
        .querySelectorAll(".menu--main .menu-item--expanded")
        .forEach((menu) => {
          const levelElement = menu.querySelector('[class^="menu-level-"]');
          menu
            .querySelector(".menu-item-expanded-plus")
            .addEventListener("click", (e) => {
              levelElement.classList.add("menu-level-animation");
            });

          levelElement
            .querySelector(".menu-item-back")
            .addEventListener("click", (e) => {
              levelElement.classList.remove("menu-level-animation");
            });
        });

      break;
    // Dropdown menu
    case "variant-2":
      headerEl
        .querySelectorAll(".menu--main .menu-item--expanded")
        .forEach((mainMenuItem) => {
          mainMenuItem
            .querySelector(".menu-item-expanded-plus")
            .addEventListener("click", (e) => {
              e.target.classList.toggle("active");
              toggleHeight(mainMenuItem.querySelector("ul"));
            });

          /* mainMenuItem.querySelector("span").addEventListener("click", (e) => {
            mainMenuItem
              .querySelector(".menu-item-expanded-plus")
              .classList.toggle("active");
            toggleHeight(mainMenuItem.querySelector("ul"));
          }); */

          mainMenuItem
            .querySelectorAll(".menu-item-expanded")
            .forEach((subMenuItem) => {
              subMenuItem
                .querySelector(".menu-item-expanded-plus")
                .addEventListener("click", (e) => {
                  e.target.classList.toggle("active");
                  toggleHeight(subMenuItem.querySelector("ul"));
                });

              subMenuItem
                .querySelector("span")
                .addEventListener("click", (e) => {
                  subMenuItem
                    .querySelector(".menu-item-expanded-plus")
                    .classList.toggle("active");
                  toggleHeight(subMenuItem.querySelector("ul"));
                });
            });
        });

      headerEl.querySelectorAll(".block-language").forEach((langMenu) => {
        langMenu
          .querySelector(".menu-item-expanded-plus")
          .addEventListener("click", (e) => {
            e.target.classList.toggle("active");
            toggleHeight(langMenu.querySelector(".links"));
          });

        langMenu.querySelector("span").addEventListener("click", (e) => {
          e.target.classList.toggle("active");
          toggleHeight(langMenu.querySelector(".links"));
        });
      });
      break;
    default:
      headerEl.querySelectorAll(".menu-item--expanded").forEach((menu) => {
        const levelElement = menu.querySelector('[class^="menu-level-"]');
        menu
          .querySelector(".menu-item-expanded-plus")
          .addEventListener("click", (e) => {
            levelElement.classList.add("menu-level-animation");
          });

        menu.querySelector("span").addEventListener("click", (e) => {
          levelElement.classList.add("menu-level-animation");
        });

        levelElement
          .querySelector(".menu-item-back")
          .addEventListener("click", (e) => {
            levelElement.classList.remove("menu-level-animation");
          });
      });
      break;
  }

  const navigationElement = document.querySelector(".main-navigation");

  if (navigationElement) {
    handleMenuResponsiveToggle();
    // Check on window resize with debouncing
    window.addEventListener("resize", () => {
      handleResize(resizeTimeout);
    });
  }

  //Language selector (hide active language)
  const languageBlock = document.querySelector(".language-switcher-language-url")

  if (languageBlock) {
    const htmlLang = document.documentElement.lang;

    languageBlock.style.visibility = "visible";

    const liElements = languageBlock.querySelectorAll(".links li");

    let activeIndex = null;

    liElements.forEach((item, index) => {
      const linkLang = item.getAttribute("hreflang");
      
      if (htmlLang === linkLang) {
        item.style.display = "none";
        activeIndex = index + 1;
      }
    })

    liElements.forEach((item, index) => {
      if (activeIndex && activeIndex === index) {
        item.style.border = "none";
      }
    })
  }
});
